import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { Row, Col, Progress } from "antd";
import { getStatPlantImage } from '../../../http/manager';

const PlantLibrary: React.FC = () => { 
    interface items {
        name: string,
        value: number,
        color: string
    }
    const [ dataSource, setDataSource ] = useState<items[]>([]);
    useEffect(()=> {
        getData();
        return;
    }, [])
    const getData = ()=> {
        getStatPlantImage({}).then((res:any)=> {
            let list:any = [];
            const colors = ['#F8C74A', '#74A0FB', '#77DEB3'];
            res.data.forEach((item:any, index:number)=> {
                item.color = colors[index];
                item.value = item.value.toFixed(2);
                list.push(item);
            })
            setDataSource(list)
        })
    }
    return (
        <LibraryContainer>
            <Row>
                { 
                    dataSource.map((item, index)=> {
                        return <Col span={8} className="item" key={index}>
                        <Progress type="dashboard" percent={item.value} strokeColor={item.color} />
                        <p className="name">{ item.name }</p>
                    </Col>
                    })
                }
            </Row>
        </LibraryContainer>
    )
}

export default observer(PlantLibrary);

const LibraryContainer = styled.div`
    & {
        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            .name {
                margin-top: -18px;
                color: rgba(0,0,0,0.85);
            }
        }
    }
`